import { RefObject } from "react";

function setRef<T>(
  ref: ((instance: T | null) => void) | RefObject<T | null> | null | undefined,
  r: T | null,
) {
  if (typeof ref === "function") {
    ref(r);
  } else if (ref) {
    ref.current = r;
  }
}

export { setRef };
